import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
export var stringifyObject = function stringifyObject(params) {
  if (params) {
    return _Object$keys(params).map(function (key) {
      return "".concat(key, "=").concat(params[key]);
    }).join('&');
  }

  return '';
};
export default {};